module.exports = __webpack_public_path__ + "img/gift1.31beeafe.png";